import { render, staticRenderFns } from "./OrderDetailsContainer.vue?vue&type=template&id=675e87d0"
import script from "./OrderDetailsContainer.vue?vue&type=script&lang=js"
export * from "./OrderDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsContainer.vue?vue&type=style&index=0&id=675e87d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports